function cov_1m4ayordkx() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronRight.tsx";
  var hash = "8bc5d27d1b71da2697b9377c2e1daa79b0844106";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronRight.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 53
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8bc5d27d1b71da2697b9377c2e1daa79b0844106"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1m4ayordkx = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1m4ayordkx();
var Icon = (cov_1m4ayordkx().s[0]++, {
  name: 'chevron-right',
  svg: "<path xmlns=\"http://www.w3.org/2000/svg\" d=\"M15.8308 11.9921L8.29809 4.45942C8.09938 4.26071 8.00258 4.02673 8.00772 3.7575C8.01285 3.48828 8.11478 3.25432 8.31349 3.0556C8.51219 2.85688 8.74616 2.75752 9.01539 2.75752C9.28463 2.75752 9.51859 2.85688 9.71729 3.0556L17.3884 10.7114C17.5692 10.8921 17.7032 11.0947 17.7904 11.319C17.8776 11.5434 17.9211 11.7678 17.9211 11.9921C17.9211 12.2165 17.8776 12.4408 17.7904 12.6652C17.7032 12.8896 17.5692 13.0921 17.3884 13.2729L9.71729 20.944C9.51859 21.1427 9.28206 21.2395 9.00769 21.2344C8.73334 21.2293 8.49681 21.1274 8.29809 20.9287C8.09938 20.7299 8.00002 20.496 8.00002 20.2268C8.00002 19.9575 8.09938 19.7235 8.29809 19.5248L15.8308 11.9921Z\" fill=\"currentColor\"/>"
});
export default Icon;